import { loadScript, removeScripts } from 'common-utils';

import { TrackingTool } from '../tracking-tool';

declare global {
  interface Window {
    // eslint-disable-next-line
    ytag: any;
  }
}

export class Yahoo implements TrackingTool {
  private readonly _id: string;
  private readonly _conversionId: string;
  private readonly _yjadConversion: string;

  constructor(id: string, conversionId: string, yjadConversion: string) {
    this._id = id;
    this._conversionId = conversionId;
    this._yjadConversion = yjadConversion;
  }

  getName(): string {
    return 'yahoo';
  }

  trackSpecialEvent = {
    onUserCreated: async () => {
      yahooConversionCode(this._conversionId, this._yjadConversion);
    },
  };

  async turnOff() {
    removeScripts(['https://s.yimg.jp/images/listing/tool/cv/ytag.js']);
  }

  async turnOn() {
    if (typeof window !== 'undefined') {
      const src = 'https://s.yimg.jp/images/listing/tool/cv/ytag.js';
      await loadScript(src);
      const script = document.createElement('script');
      script.text = `
      window.yjDataLayer = window.yjDataLayer || [];
      function ytag() { yjDataLayer.push(arguments); }
      ytag({"type":"ycl_cookie"});
    `;
      window.ytag?.('yjad_retargeting', {
        yahoo_retargeting_id: this._id,
        yahoo_retargeting_label: '',
        yahoo_conversion_id: '',
        yahoo_conversion_label: '',
        yahoo_conversion_value: '',

        yahoo_retargeting_items: [
          {
            item_id: '',
            category_id: '',
            price: '',
            quantity: '',
          },
        ],
        yahoo_retargeting_page_type: '',
      });
    }
  }
}

function yahooConversionCode(
  yahooConversionId: string,
  yjad_conversion: string,
) {
  if (typeof window !== 'undefined') {
    window.ytag?.('yss_conversion', {
      yahoo_conversion_id: yahooConversionId,
      yahoo_conversion_label: '',
      yahoo_conversion_value: '',
      yahoo_retargeting_id: '',
      yahoo_retargeting_label: '',

      yahoo_retargeting_items: [
        {
          item_id: '',
          category_id: '',
          price: '',
          quantity: '',
        },
      ],
      yahoo_retargeting_page_type: '',
    });

    window.ytag?.('yjad_conversion', {
      yahoo_ydn_conv_io: yjad_conversion,
      yahoo_ydn_conv_label: 'G6IJWGRB2TNFO29XDHO982657',
      yahoo_ydn_conv_transaction_id: '',
      yahoo_ydn_conv_value: '1',
    });
  }
}
